import { supabase } from "@/integrations/supabase/client";

export { supabase };

/**
 * Returns the currently signed-in user's id, throwing if there is no session.
 *
 * Offline-tolerant: prefers the cached local session (no network) so this
 * helper works after landing on flaky LTE with an expired access token.
 * `supabase.auth.getUser()` requires reaching the auth server and returns
 * "Auth session missing!" on failure — a misleading error when a refresh
 * token is sitting in storage. We only fall back to `getUser()` when there
 * is truly no cached session at all.
 */
export async function requireUserId(): Promise<string> {
  const { data: { session } } = await supabase.auth.getSession();
  if (session?.user?.id) return session.user.id;
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error) throw new Error(error.message);
  if (!user) throw new Error("Not signed in");
  return user.id;
}

// NOTE: assertAdmin / assertTripAdmin removed. Admin authorization must be
// enforced server-side — either via RLS or via SECURITY DEFINER RPCs (see
// admin_* functions). Client-side checks are bypassable.
